import { notify } from './store';

export { notify };

export default () => notify;
